import dayjs from 'shared/helpers/dayjs';
import { EventTimelineNote } from 'events/_types';

function extractUrgency(note: EventTimelineNote): string | undefined {
  return note.entity_extractions?.find(
    (e) => e.extraction_class_key.toLowerCase() === 'urgency'
  )?.attributes?.categories?.[0];
}

export default function getEventUrgencyKey(
  notes: EventTimelineNote[]
): string | null {
  if (!notes.length) return null;
  const sortedByRecency = [...notes].sort(
    (a, b) => dayjs(b.created).valueOf() - dayjs(a.created).valueOf()
  );
  return (
    sortedByRecency
      .map(extractUrgency)
      .find((u): u is string => u !== undefined) ?? null
  );
}
